export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "Introduce una contraseña nueva",
        "Empty": "空",
        "No data": "No hay datos",
        "Update Package": "Paquete de actualización",
        "Settings - Profiles": "Configuración - Perfiles",
        "User Management": "Gestión de usuarios",
        "Operation Records": "Registros de operación",
        "Exit": "Salir",
        "Total pages:": "Total de páginas: ",
        "page": "página",
        "Go to": "Ir a",
        "Prev": "Anterior",
        "Next": "Siguiente",
        "per page": "Por Página",
        "items": "Artículo",
        "Please enter the page number to go to": "请输入前往页数",
        "Language": "Idioma",
        "Profile Picture": "Foto de perfil",
        "Old Password": "Contraseña antigua",
        "New Password": "Contraseña nueva",
        "Confirm Password": "Confirmar contraseña",
        "The two passwords entered do not match": "Las dos contraseñas introducidas no coinciden",
        "Enter the new password again": "Vuelve a introducir la contraseña nueva.",
        "This must match the new password above": "que debe coincidir con la contraseña nueva introducida.",
        "Invalid input。Password length must be 8–16 characters": "Entrada no válida. La longitud de la contraseña debe ser de entre 8 a 16 caracteres",
        "Lenovo Privacy Statement": "la Declaración de privacidad de Lenovo",
        "Lenovo Software License Agreement": "Acuerdo de licencia de software de Lenovo",
        "Third-Party Notice": "Notificación de terceros",
        "Third-party notifications":"Notificaciones de terceros",
        "Change Password": "Cambiar contraseña",
        "Edit Profile": "Editar perfil",
        "Exited successfully": "Has salido correctamente",
        "Admin": "Administrador",
        "Common user": "Usuario común",
        "Super Admin":"Súper Administrador",
        "Model": "Modelo",
        "Are you sure you want to delete this?": "¿Estás seguro de que deseas eliminar esto?",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "Introduce una contraseña nueva.Esta debe incluir al menos tres de los siguientes elementos: letras mayúsculas, letras minúsculas, números y caracteres especiales.",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters":"Esta debe incluir al menos tres de los siguientes elementos: letras mayúsculas, letras minúsculas, números y caracteres especiales.",
        "Tip": "Consejo",
        "Confirm": "Confirmar",
        "Cancel": "Cancelar",
        "Deletion successful": "La eliminación se realizó correctamente",
        "Password changed successfully": "La contraseña se cambió correctamente",
        "The file to upload is larger than 100 MB。 Please select another one。": "El archivo de carga es de más de 100 MB. Selecciona otro.",
        "Your session has expired。 Please log in again。": "¡El estado actual de inicio de sesión ha expirado, ¡ por favor, vuelva a iniciar sesión!",
        "Invalid network request URL": "la dirección de solicitud de la red no es correcta!",
        "Unknown server error": "Se produjo un error desconocido en el servidor!",
        "An unknown error has occurred": "Se produce un error desconocido!",
        "Request timeout。 Please check your network and try again。": "Se agotó el tiempo de espera de la solicitud. Comprueba la red e inténtalo de nuevo.",
        "Failed to connect to server": "No se pudo conectar con el servidor",
        "Your network may be currently disconnected": "Es posible que la red esté desconectada actualmente",
        "No related device found": "No se encontró el equipo relevante",
        "Pre-upgrade component not found in the device": "No se encontró el componente de actualización previa en el dispositivo",
        "FWID of the installation component not found": "Componente de instalación fwid no encontrado",
        "Failed to set upgrade information": "Falló la configuración de la información de actualización",
        "Failed to set specified update options": "Falló la configuración de actualización especificada",
        "Failed to install the update package": "Falló la instalación del paquete de actualización",
        "Failed to obtain the device handle": "Falló la obtención de la manija del dispositivo",
        "Upgrade device mismatch": "El dispositivo de actualización no coincide",
        "Installation failed: Pre-upgrade component not found in the device": "No se puede instalar: no se ha encontrado ningún componente de actualización previa en el dispositivo",
        "Installation failed: FWID mismatch in the component list": "No se puede instalar: fwid no coincide en el componente",
        "Installation failed: No matching monitor found for upgrade": "No se puede instalar: no se ha encontrado una pantalla que coincida con la actualización",
        "The monitor does not exist": "El monitor no existe",
        "The command has been sent": "El comando ha sido enviado",
        "The group does not exist": "El grupo no existe",
        "The command does not exist": "El comando no existe",
        "Setting does not exist": "La configuración no existe",
        "The settings profile does not exist": "El perfil de configuración no existe",
        "The update package does not exist": "El paquete de actualización no existe",
        "The update package record does not exist": "El registro del paquete de actualización no existe",
        "Invalid password format。 It must be between 8 and 30 characters long。": "Formato de contraseña no válido. Debe tener entre 8 y 30 caracteres.",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "El campo está vacío",
        "Update time cannot be null": "升级时间不能为空",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "Hora de actualización no válida. No puede ser anterior a la hora actual ni más de 30 días en el futuro.",
        "Uploaded file is null": "上传文件为空",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "El formato de archivo de carga no es correcto, el formato de archivo solo puede ser zip / EXE / DMG / APP",
        "Uploaded file format is incorrect， file cannot have no extension": "El formato de archivo de carga no es correcto, el archivo no puede estar sin sufijo",
        "Login failed。 Make sure you entered the correct account ID and password。": "Error de inicio de sesión. Asegúrate de haber introducido el ID de cuenta y la contraseña correctos.",
        "Date": "Fecha",
        "Time": "Tiempo",
        "The data will be permanently deleted": "Esta operación eliminará permanentemente los datos actuales y si continúa?",
        "Please select an item to delete first": "Por favor, Seleccione uno antes de eliminarlo.",
        "Select an item and then delete":"Seleccione un elemento y, a continuación, elimínelo",
        "Begin Download": "Empezar a descargar",
        "Start Download":"Iniciar descarga",
        "Password incorrect": "Contraseña Incorrecta",
        "Password Changed Successfully": "Se modificó con éxito la contraseña",
        "Display ID or Group ID is empty": "El ID de la pantalla o el id del Grupo están vacíos",
        "Select the update package": "Seleccionar el paquete de actualización",
        "Username already exists": "El nombre de usuario ya existe",
        "Executing monitor setting command。Please wait 10s before making new changes。": "La orden de configuración del monitor se está ejecutando, por favor espere 10 segundos antes de hacer una nueva configuración.",
        "Close": "Apagado",
        "Role does not exist。 Cannot modify role。": "El personaje no existe y no se puede modificar el personaje",
        "Unknown Command": "Orden desconocida",
        "Access Token Expired": "El token de acceso ha expirado",
        "Invalid Refresh Token": "Token de actualización no válido",
        "Missing Request Parameters:": "Falta el parámetro de solicitud:",
        "Incorrect Request Parameter Type:": "Tipo de parámetro de solicitud incorrecto:",
        "Request URL Not Found:": "La Dirección de la solicitud no existe:",
        "Incorrect Request Method:": "El método de solicitud es incorrecto:",
        "Log In": "Iniciar sesión",
        "account ID": "Cuenta",
        "password": "Contraseña",
        "Update failed": "Error de actualización",
        "Reset Password?": "Restablecer contraseña",
        "Logged in successfully": "Has iniciado sesión correctamente",
        "Please contact the system administrator to reset your password": "Ponte en contacto con el administrador del sistema para restablecer la contraseña.",
        "Retry limit exceeded。 Please try again after 30 minutes": "Vuelva a intentarlo más de 5 veces, vuelva a intentarlo en 30 minutos.",
        "Enter the model / host name / firmware version number": "Introduce el modelo, el nombre de host o el número de versión de firmware",
        "New Group": "Nuevo grupo",
        "Delete Group": "Eliminar grupo",
        "Display Columns": "Columnas de visualización",
        "Collapse": "Contraer",
        "Expand": "Expandir",
        "Move To": "Mover a",
        "Export": "Exportar",
        "Power On": "Encender",
        "Power Off": "Apagar",
        "Screen lock": "Bloqueo de pantalla",
        "Unlock screen": "Desbloqueo de la pantalla",
        "Settings": "Configuración",
        "Export Settings Profiles": "Exportar perfiles de configuración",
        "Settings Profiles": "Perfiles de configuración",
        "Update": "Actualizar",
        "Delete Monitor": "Eliminar monitor",
        "Total devices": "Total de dispositivos",
        "Selected devices": "Dispositivos seleccionados",
        "Update package name": "Nombre del paquete de actualización",
        "Update Time": "Hora de actualización",
        "Apply to all displays of the same model": "Se aplica al mismo modelo de pantalla",
        "Display Settings": "Configuración de pantalla",
        "Select All": "Seleccionar todo",
        "Filename": "Nombre del archivo",
        "Group": "Grupo",
        "Monitor Model": "Modelo de monitor",
        "Special ID": "Identificación especial",
        "Host Name": "Nombre del host",
        "Host Status": "Estado del host",
        "Monitor Status": "Estado del monitor",
        "Lock Status": "锁定状态",
        "Update Progress": "Progreso de la actualización",
        "Settings Profile": "Perfil de configuración",
        "Tips": "Consejos",
        "Active Time": "Tiempo activo",
        "Overclock": "Sobrefrecuencia",
        "Operation successful": "La operación se realizó correctamente",
        "Please save data": "Guarda los datos",
        "Select the data first": "Selecciona los datos primero",
        "Cannot modify when ungrouped": "No se puede modificar cuando está desagrupado",
        "Deselect All": "Deseleccionar todo",
        "Select the GAMMA node label value": "Selecciona el valor de etiqueta del nodo GAMMA",
        "Ungrouped": "Sin agrupar",
        "Offline": "Sin conexión",
        "Online": "En línea",
        "Power on": "Encendido",
        "Power off": "Apagado",
        "Locked": "Bloqueado",
        "Open": "No bloqueado",
        "Not connected": "No conectado",
        "Connected": "Conexión",
        "Set the update start time": "Establecer la hora de inicio de la actualización",
        "Now": "Ahora",
        "Set upgrade mode": "Establecer el modo de actualización",
        "Interactive Mode": "Modo interactivo",
        "Silent mode": "Modo silencioso",
        "In this mode， a monitor firmware update screen will appear and request users confirmation to proceed! Users may choose to postpone the update twice, after which the update will be enforced": "En este modo, aparecerá una pantalla de actualización de firmware del monitor y solicitará la confirmación de los usuarios para continuar. Los usuarios pueden optar por posponer la actualización dos veces, después de lo cual la actualización se aplicará.",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "En este modo, cuando el monitor esté en línea, la actualización de firmware se realizará automáticamente en segundo plano. Los usuarios no verán ninguna notificación. La actualización surtirá efecto cuando se reinicie la pantalla. El reinicio del monitor tarda unos segundos y no afectará a las tareas en curso en el equipo.",
        "Invalid input": "Entrada no válida",
        "Failed to log in": "No se pudo iniciar sesión",
        "Select your preferred restart time。": "Selecciona la hora de reinicio que prefieras en función de tu uso.",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "Introduce el nombre del grupo",
        "Apply profile:": "Aplicar perfil:",
        "A new version is available": "Hay una nueva versión disponible",
        "Restart monitor immediately after update": "Reiniciar el monitor inmediatamente después de la actualización",
        "Restart when the monitor enters sleep mode": "Reiniciar cuando el monitor entre en la modalidad de suspensión",
        "Restart monitor when it disconnected from all PCs": "Reiniciar cuando el monitor está desconectado y todas las conexiones de PC",
        "Enter the model name": "Introduce el nombre del modelo",
        "Create Update Task": "Crear tarea de actualización",
        "Update Task List": "Actualizar lista de tareas",
        "Cancel All": "Cancelar todo",
        "View Details": "Ver detalles",
        "Update Details": "Detalles de la actualización",
        "Update Mode": "Modo de actualización",
        "Update Creation Time": "Hora de creación de la actualización",
        "Update Start Time": "Hora de inicio de la actualización",
        "Are you sure you want to cancel all tasks?": "¿Estás seguro de que deseas cancelar todas las tareas?",
        "Are you sure you want to cancel this task?": "¿Estás seguro de que deseas cancelar esta tarea?",
        "Are you sure you want to delete the selected monitor?": "¿Estás seguro de que deseas eliminar el monitor seleccionado?",
        "Confirm to delete all displays?": "Eliminare il monitor selezionato?",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "¿Estás seguro de que deseas eliminar esto? (No se puede eliminar cuando está desagrupado)",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "Consejo: Si una opción de los ajustes de pantalla aparece atenuada, es posible que esté restringida por otro ajuste. Intenta ajustar otros valores para eliminar la restricción.",
        "The WebSocket connection has been restored": "Se ha restaurado la conexión de WebSocket.",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        "Please copy this password into the input box: ": "Copia esta contraseña en el cuadro de entrada: ",
        "Ebook": "Libro electrónico",
        "largest": "mayor",
        "Max":"Máxima",
        "Turn off auto mode": "Apagar el modo automático",
        "Minimum": "Mínimo",
        "Restore Factory Settings": "Restaurar la configuración de fábrica",
        "Scenario Mode": "Modo escenario",
        "Color Gamut & Color Temperature": "Gama y temperatura de colores",
        "Panel Native": "Mostrar nativo",
        "Close PIP, PBP":"Cierre",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Neutral": "Neutral",
        "Neutral(7500K)":"Neutral",
        "Reddish(6500K)":"Cálido",
        "Bluish(9300K)":"Frío",
        "Warm": "Cálido",
        "Cool": "Frío",
        "Low Blue Light": "Luz azul baja",
        "Custom 1": "Personalizada 1",
        "Custom 2": "Personalizada 2",
        "Custom 3": "Personalizada 3",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "Señal de video",
        "Game Mode": "Modo de juego",
        "Off": "Apagado",
        "Game 1": "Juego 1",
        "Game 2": "Juego 2",
        "Response Time": "Tiempo de respuesta",
        "Normal": "Normal",
        "Extreme": "Extremo",
        "Level 1": "Nivel 1",
        "Level 2": "Nivel 2",
        "Level 3": "Nivel 3",
        "Level 4": "Nivel 4",
        "Level 5": "Nivel 5",
        "Lan Indicator": "Indicador LAN",
        "Linked": "Vinculado",
        "No Link": "No vinculado",
        "Blinking": "Parpadeando",
        "Brightness": "Contraste",
        "Contrast": "Brillo",
        "Smart Light": "Luz inteligente",
        "Volume Control": "Control de volumen",
        "USB Select": "Selección de USB",
        "DP Select": "Selección de DP",
        "Aspect Ratio": "Relación de aspecto",
        "Smart Traffic Light": "Semáforo Inteligente",
        "daisy chain": "Cadena margarita",
        "Dynamic Contrast": "Contraste dinámico",
        "Smart Energy": "Energía inteligente",
        "Smart Audio": "Audio Inteligente",
        "Distance Warning": "Advertencia de distancia",
        "Ambient Light Detection": "Detección de luz ambiental",
        "Enabled Ambient Light Detection": "Habilitar detección de luz ambiental",
        "enabled":"enabled",
        "Waken on Touch": "Despertar al tacto",
        "True Split": "Separación de pantalla",
        "Face Tracking": "Rastreo Facial",
        "Audio Smart Switch": "Interruptor de Audio Inteligente",
        "Auto-alarm": "Alarma automática",
        "KVM Switch": "Cambiar KVM",
        "KVM切换": "Cambiar KVM",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "El Switch KMV (Teclado, Video, Ratón) permite a dos PC usar un set de monitor, teclado y ratón, Activar cambio simultáneo de video, teclado y ratón. Si está desactivado, sólo cambia teclado y ratón",
        "Sitting Reminder": "Recordatorio de sesión",
        "Gaming": "Juegos",
        "RGB Gain": "Ajuste de color",
        "Serial No": "N.º de serie",
        "Firmware Version": "Versión de firmware",
        "Select response time level": "Selecionar nivel de tiempo de respuesta",
        "Enable daisy chain": "Habilitar cadena margarita",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "El Semáforo Inteligente es una luz de no molestar que ayuda a reducir las distracciones",
        "Enable/Disable the Audio Smart function": "Activar/Desactivar función de Audio Inteligente",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "La Alarma automática indica si la cámara/micrófono en el monitor esta o no en uso",
        "Enable Distance Warning": "Habilitar advertencia de distancia",
        "Enable/disable face tracking": "Activar/Desactivar rastreo facial",
        "Enable Sitting Reminder": "Habilitar recordatorio de sesión",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "La tecnología de Audio Inteligente le permite concentrarse en el sonido que tiene delante de usted para mejorar la claridad de la voz",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "La tecnología de Energía Inteligente administra de manera automática el consumo de energía mediante un sensor de detección humano",
        "Implement PBP through only one cable": "Implementar PBP mediante un solo cable",
        "Enable/Disable vPro technology in the monitor": "Activar/Desactivar función vPro en el monitor",
        "Wake system by touch": "Despertar el sistema con el tacto",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "Ajustar fuente de video y USB (usada por el teclado y ratón) para cada PC",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM da acceso instantáneo a dos ordenadores presionando simultáneamente los dos botones del ratón",
        "Enable USB charging always on": "Habilitar la carga USB siempre",
        "Select DP version": "Seleccionar versión DP",
        "USB Charging": "Carga USB",
        "PC": "PC",
        "Double-click the CTRL": "Haz doble clic en CTRL",
        "Full Screen": "Pantalla completa",
        "Original AR": "AR original",
        "No scaling": "Sin ajuste de escala",
        "on": "Abrir",
        "On": "Abrir",
        "Keyboard On": "Usar teclado",
        "Mouse On": "Usar ratón",
        "Image Creation": "Creación de imágenes",
        "Digital Cinema": "Cine digital",
        "Video Creation": "Creación de video",
        "Web Browsing": "Navegación web",
        "Professional Image": "Imagen profesional",
        "DisplayPort": "DisplayPort",
        "Auto": "Automático",
        "Refresh": "Actualizar",
        "Search": "Buscar",
        "Record": "Registro",
        "Username": "Nombre de usuario",
        "Upload Time": "Tiempo de carga",
        "Add Profiles": "Agregar perfiles",
        "Latest Update Package": "Paquete de actualización más reciente",
        "Upload Update Package": "Cargar el paquete de actualización",
        "Upload": "Cargar",
        "Size": "Tamaño",
        "Upload successful": "La carga se realizó correctamente",
        "Download successful": "La descarga se realizó correctamente",
        "Refresh successful": "La actualización se realizó correctamente",
        "The upgrade package does not match the device model": "El paquete de actualización no coincide con el modelo",
        "Upgrade package does not match the device model":"El paquete de actualización no coincide con el modelo de dispositivo",
        "Please enter the setting name": "Introduzca el nombre de la configuración",
        "Edit": "Editar",
        "Save": "Guardar",
        "Delete": "Eliminar",
        "Add": "Agregar",
        "Reset Password": "Restablecer contraseña",
        "No": "N.°",
        "Full Name": "Nombre completo",
        "Role": "Rol",
        "Creation Date": "Fecha de creación",
        "Operation": "Operación",
        "Actions": "Operación",
        "The user's initial password is ": "La contraseña inicial de este usuario es:",
        "The password has been reset to：": "La contraseña se ha restablecido a: ",
        "Invalid input。Usernames can only contain numbers and letters。": "Entrada no válida. El nombre de usuario consta de números y letras.",
        "Invalid input。The username must contain 4 to 30 characters。": "Entrada no válida. El nombre de usuario debe contener de 4 a 30 caracteres.",
        "Installation Package": "Paquete de instalación",
        "Operation Date": "Fecha de operación",
        "Actions": "Acciones",
        "Operator": "Operador",
        "Paging component": "Componente de paginación",
        "Quick page flipping": "Voltar página rápida",
        "Current page": "Página actual",
        "Title": "Título",
        "Details": "Detalles",
        "This is the expanded area": "Esta es la zona ampliada",
        "Set Display Column": "Set Display Column",
        "Upload file": "Upload file",
        "Drop-down to expand": "Drop-down to expand",
        "Default": "Por defecto",
        "Default Info": "Información predeterminada",
        "Personal Center": "Centro personal",
        "Personal center image button": "Personal center image button",
        "Expandable area": "Área ampliable",
        "Update Package Table": "Actualizar la tabla de paquetes",
        "This is the table header": "Este es el encabezado de la tabla",
        "This is the table content": "Este es el contenido de la tabla",
        "UserList Table": "Tabla de la lista de usuarios",
        "Page Up and Down": "Página arriba y abajo",
        "Operation record table": "Tabla de registro de operación",
        "OSD upgrade details": "Detalles de actualización de OSD",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "Carga USB-C",
        "PIP": "PIP",
        "PBP": "PBP",
        /*
        "Simplified Chinese": "Chino simplificado",
        "English": "Inglés",
        "Traditional Chinese": "繁体中文",
        "French": "Francés",
        "German": "Alemán",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "Japonés",
        "Thai": "Tailandés",
        "Ukrainian": "乌克兰语",
        "Russian": "Ruso",
        */
        "Enter your account ID": "Ingresa el ID de tu cuenta",
        "Please Enter your account id":"Ponte en contacto con el administrador del sistema para restablecer la contraseña.",
        "Enter your password": "Ingresa tu contraseña",
        "Cannot exceed 20 characters": "No puedes exceder los 20 caracteres",
        "Enter the original password": "Introduce la contraseña original",
        "You have still selected the group that the device currently belongs to。 If you want to move the device, please select another group。": "Aún tienes seleccionado el grupo al que pertenece actualmente el dispositivo. Si deseas mover el dispositivo, selecciona otro grupo. ",
        "Enter the filename": "Introduce el nombre del archivo",
        "Update Package Name": "Nombre del paquete de actualización",
        "Select the date": "Seleccionar la fecha",
        "Select the time": "Seleccionar la hora",
        "Set the update mode": "Establecer el modo de actualización",
        "Restart when the monitor is not connected to any computer": "Reiniciar cuando el monitor no esté conectado a ningún equipo",
        "Invalid file format": "Formato de archivo no válido. Solo se admiten archivos zip/exe/dmg/app.",
        "Select a valid file type": "Selecciona un tipo de archivo válido",

        "The data is being processed。 Please do not submit again。": "Los datos están siendo procesados. No vuelvas a enviarlos.",
        "Enter the profiles name": "Introduce el nombre del perfil",
        "Enter your username": "Introduce tu nombre de usuario",
        "Enter your full name": "Introduce tu nombre completo",
        "Select your role": "Selecciona tu rol",
        "User Profile": "Perfil de usuario",
        "Downloading": "Descargando...",
        "Enter the new password again。Two times of new password input is same": "Vuelve a introducir la contraseña nueva.La contraseña nueva debe coincidir con la entrada anterior.",
        "Request failed with status code 502": "Solicitud fallida con código de estado 502",

        "Please Enter your x": "Introduce {param}",
        "Select the x": "Selecciona {param}",
        "Please select the correct file type x": "Selecciona un tipo de archivo válido {param}",
        "Please select the correct file type": "Selecciona un tipo de archivo válido",
        "Input characters within x characters": "Geben Sie Zeichen innerhalb von {param} Zeichen ein",

        "Monitor List":"Lista de monitores",
        "List of update packages":"Lista de paquetes de actualización",
        "Settings - Profiles":"Configuración - Perfiles",
        "User Management":"Gestión de usuarios",
     

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"Anomalías del sistema",

        "Upgrade Package Record ID is empty":"Seleccionar el paquete de actualización",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"Hora de actualización inválida. No puede ser antes de la hora actual o más de 30 días en el futuro.",
       
        "The WebSocket connection has been lost Reconnecting":"Se ha perdido la conexión WebSocket",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"El parámetro de solicitud es inválido:El nombre de usuario consta de números y letras.",


        "Request parameter is invalid:Password length must be between 8-16 character":"El parámetro de la solicitud no es válido:La longitud de la contraseña debe estar entre 8 y 16 caracteres.",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"Falta el paquete compilado: el componente tiene un contenedor correspondiente que no ha sido cargado. Por favor, cargalo antes de compilarlo.",

        "Request parameter is invalid：Password length must be 8–16 characters":"El parámetro de la solicitud no es válido:La longitud de la contraseña debe estar entre 8 y 16 caracteres",


        "Illegal request header!": "Encabezado de solicitud ilegal!",
        "Invalid request parameters":"Parámetros de solicitud no válidos",

        "Export": "Exportar",
        "It is already a high-version and there is no need to upgrade":"Ya es una versión alta y no hay necesidad de actualizar",
        "Repeated request， please try again later":"Repeated request, please try again later",
        "Communication":"Communication"
    }
}